import { IFilterForm } from 'components/filter-popover';
import dayjs from 'dayjs';

export const getFilterCount = (formValues: IFilterForm) => {
  const strictFields = ['isFileIncluded', 'isPhotoIncluded'];

  return Object.entries(formValues).filter(([key, val]) => {
    if (strictFields.includes(key)) {
      return val !== null && val !== false;
    }
    return val !== null;
  }).length;
};

export const getFilteredValues = (formValues: IFilterForm) =>
  Object.fromEntries(
    Object.entries(formValues)
      .filter(
        (value) => !Object.is(value[1], null) && !(Array.isArray(value[1]) && !value[1]?.length)
      )
      .map((filteredValue) => {
        switch (filteredValue[0] as keyof IFilterForm) {
          case 'fromDate':
            return [filteredValue[0], dayjs(filteredValue[1]).toISOString()];
          case 'toDate':
            return [filteredValue[0], dayjs(filteredValue[1]).add(1, 'd').toISOString()];
          case 'phasesIds':
          case 'phaseItemsIds':
            return [filteredValue[0], [filteredValue[1]]];
          default:
            return filteredValue;
        }
      })
  );
